export const SearchListingContainer = ({
  children,
  className = '',
  isFocused = false,
}) => {
  return (
    <section className="search-wrap max-w-[1120px] mx-auto">
      <div
        id="search-section"
        className={`search-wrap-section scroll-m-[240px] lg:scroll-m-[460px] search-box max-w-8xl flex max-lg:flex-wrap items-center bg-white w-full relative z-10 rounded-[20px] ${
          isFocused ? '!bg-slate-100 bg-focused' : ''
        } ${className}`}
      >
        {children}
      </div>
    </section>
  );
};
